import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ContentLayout,
  ContentWrapper,
  ContentMenu,
  ContentTable,
} from "../../../pages/style";
import { Outlet } from "react-router-dom";
import { List, ListIcon, ListItem, ListText } from "../../../ppui/list";
import { TbCalendarExclamation, TbTextScan2 } from "react-icons/tb";

function EmployeeLeaveManage() {
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = [
    {
      icon: <TbTextScan2 />,
      primaryText: "Leave Information",
      path: "/leave-manage",
    },
    {
      icon: <TbCalendarExclamation />,
      primaryText: "Requested leave",
      path: "/leave-manage/leave-request",
    },
  ];

  return (
    <>
     <ContentLayout>


      <ContentWrapper>
     
            <ContentMenu>
              <List
                size={"md"}
                color={"default"}
                activeColor={"default"}
                Colorvariant={"dark"}
                hover={"secondary"}
                gap={15}
              >
                {menuItems.map((item, index) => (
                  <ListItem
                    key={index}
                    onClick={() => navigate(item.path)}
                    className={location.pathname === item.path ? "active" : ""}
                    isActive={location.pathname === item.path} // Set isActive to true if paths match
                    colorVariant="light"
                  >
                    <ListIcon>{item.icon}</ListIcon>
                    <ListText primary={item.primaryText} />
                  </ListItem>
                ))}
              </List>
            </ContentMenu>
            <ContentTable>
              <Outlet />
            </ContentTable>
      </ContentWrapper>
      </ContentLayout>
    </>
  );
}

export default EmployeeLeaveManage;
